<template>
	<div class="popup popup--mini" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">После утверждения {{ type === 'CO' ? 'запроса' : 'тендера' }} его редактирование будет недоступно, уверены, что хотите продолжить?</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="popup__btns">
					<button class="btn btn--color" @click.prevent="sendForm">Да</button>
					<button class="btn btn--border" @click="$emit('close')">Нет</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Fetch from "@/utils/Fetch";
import {useToast} from "vue-toastification";


export default {
	name: 'AddBlackListPopup',
	props: {
		tenderId: {
			type: Number,
		},
		type: {
			type: String,
			required: true,
		}
	},
	data() {
		return {
			toast: useToast(),
		}
	},
	methods: {
		async sendForm() {
			let response = await Fetch(`tenders/confirm/${this.tenderId}/`, {
				method: 'POST',
			})
			if(response.success) {
				this.toast.success(`${this.type === 'CO' ? 'Запрос' : 'Тендер'} успешно утвержден`);
				this.$emit('close')
				setTimeout(() => {
					window.location.href = `/personal/tenders/?ID=${this.tenderId}`
				}, 1500)
			} else {
				this.toast.error(response.message);
			}
		},
	},
}
</script>
